import { Component, computed, DestroyRef, inject, signal } from '@angular/core'
import { PageHeaderComponent } from '../public/page-header/page-header.component'
import { AppLink, HomePageService } from './home-page.service'
import { Temporal } from 'temporal-polyfill'
import { LinksCardComponent } from './links-card.component'
import { NavGroup, navGroups } from '../routes'

const refreshTimeIntervalSeconds = 60
const maxRecentLinks = 9

@Component({
  imports: [
    PageHeaderComponent,
    LinksCardComponent,
  ],
  selector: 'app-home-page',
  template: `
    <div app-page-header header='ESS Home'></div>
    <div class='content'>
      <div class='cards'>
        <app-links-card
            header="Recently Visited"
            noLinksMessage='No recently visited pages found'
            [links]="recentRoutes()"
            [now]="now()"
        />
        @for (navGroup of navGroups; track navGroup.title) {
          <app-links-card
            [header]="navGroup.title"
            [now]="now()"
            [links]="getLinks(navGroup)"  
            (toggleFavorite)="onToggleFavorite($event)"
          />  
        }
      </div>        
    </div>
  `,
  styles: `
    .content {
      padding: 1rem 3rem 1rem 3rem;
      height: calc(100vh - 150px);
      overflow: auto;
      
      .cards {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 2rem;
      }
    }
  `,
})
export class HomePageComponent {
  private readonly homePageService = inject(HomePageService)

  protected readonly now = signal(Temporal.Now.instant())
  protected readonly timeout = signal(0)

  protected readonly recentRoutes = computed(() =>
    this.homePageService.recentRoutes().slice(0, maxRecentLinks),
  )

  protected readonly navGroups: readonly NavGroup[] = [
    navGroups.settlement,
    navGroups.dataExploration,
    navGroups.dataManagement,
    navGroups.systemConfig,
  ]

  constructor(destroyRef: DestroyRef) {
    destroyRef.onDestroy(() => {
      window.clearTimeout(this.timeout())
    })
    this.scheduleUpdateEvent()
  }

  private scheduleUpdateEvent() {
    this.timeout.set(
      window.setTimeout(() => {
        this.now.set(Temporal.Now.instant())
        this.scheduleUpdateEvent()
      }, 1000 * refreshTimeIntervalSeconds),
    )
  }

  protected getLinks(navGroup: NavGroup): readonly AppLink[] {
    return this.homePageService.getLinks(navGroup)
  }

  protected onToggleFavorite(link: AppLink) {
    if (link.favorite) {
      this.homePageService.removeFavorite(link.path)
    } else {
      this.homePageService.addFavorite(link.path)
    }
  }
}
